import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import TotalProductSales from '../productSalesReport/totalSales';
import TotalServiceSales from '../barbersReport/TotalServiceSales';
import Filters from '../filters/FiltersContainer';
import OtherSalesInfo from './OtherSalesInfo';
import DashboardTable from './DashboardTable';
import DashboardDeposits from './DashboardDeposits';
import DashboardRefunds from './DashboardRefunds';
import BarberFilter from '../barbersReport/barberFilterContainer';
import { t } from '../../../../modules/infra/i18n';

const Dashboard = ({
  servicesRevenue,
  productRevenue,
  totalRevenue,
  products,
  services,
  deposits,
  totalRefunds,
  showGiftCards,
}) => (
  <Layout title={t('reports:dashboard.total_gross_sales')}>
    <Filters disableBarberFilter>
      <div className="c-form-input-group__item u-visible-for-large-and-up">
        <div className="c-label u-ml--">{t('reports:dashboard.filter_by_barber')}</div>
        <BarberFilter showUnassigned />
      </div>
    </Filters>
    <h3>{t('reports:dashboard.total_revenue')}</h3>
    <TotalServiceSales report={totalRevenue} showGiftCards={showGiftCards} shortCount />
    <h3>{t('reports:dashboard.total_service_revenue')}</h3>
    <TotalServiceSales report={servicesRevenue} showGiftCards={showGiftCards} shortCount />
    <DashboardTable maxColumns={3} data={services} display-if={services.length > 0} />
    <h3>{t('reports:dashboard.total_product_revenue')}</h3>
    <TotalProductSales report={productRevenue} shortCount />
    <DashboardTable maxColumns={2} data={products} display-if={products.length > 0} />
    <h3>{t('reports:dashboard.other_sales_info')}</h3>
    <OtherSalesInfo report={totalRevenue} showGiftCards={showGiftCards} shortCount />
    <div className="layout u-mv-">
      <div className="layout__item u-1/1">
        <h3>{t('reports:dashboard.deposits')}</h3>
        <DashboardDeposits deposits={deposits} />
      </div>
    </div>
    <div className="u-mt">
      <h3>{t('reports:dashboard.total_refunds')}</h3>
      <DashboardRefunds totalRefunds={totalRefunds} />
    </div>
  </Layout>
);

Dashboard.propTypes = {
  servicesRevenue: PropTypes.object.isRequired,
  productRevenue: PropTypes.object.isRequired,
  totalRevenue: PropTypes.object.isRequired,
  products: PropTypes.array,
  services: PropTypes.array,
  deposits: PropTypes.object,
  totalRefunds: PropTypes.number.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
};

Dashboard.defaultProps = {
  products: [],
  services: [],
  deposits: null,
};

export default Dashboard;
